var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                { attrs: { width: "100%" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        {
                          staticClass: "title",
                          attrs: { "align-baseline": "" }
                        },
                        [
                          _c("v-flex", { attrs: { xs2: "" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("commodityInfo")) +
                                ":\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { dark: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showCommodityEditPopup(
                                        {},
                                        "add"
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("addCommodity")))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.errorMessage
                            ? _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "red--text font-weight-bold text-xs-right"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errorMessage) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "elevation-2 mt-2",
                        attrs: {
                          headers: _vm.commodityHeaders,
                          items: _vm.value,
                          "hide-actions": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v(_vm._s(props.item.productName))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.productCNName))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.countryOfOrigin))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.harmonizedCode))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.quantity))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v("$" + _vm._s(props.item.unitPrice))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.material))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    _vm._s(props.item.commodityDescription)
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.actionFrom === "createLabel"
                                  ? _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.showCommodityEditPopup(
                                                  props,
                                                  "edit"
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteCommodity(
                                                  props.index
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("FormSubmitPopup", {
                        attrs: {
                          title:
                            _vm.actionType === "add"
                              ? _vm.$t("addCommodity")
                              : _vm.$t("editCommodity"),
                          leftMethod: _vm.closeEditCommodityPopup,
                          rightMethod: _vm.onSubmit,
                          large: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "input",
                            fn: function() {
                              return [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-form",
                                      {
                                        ref: "form",
                                        attrs: { "lazy-validation": "" }
                                      },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "align-baseline": "",
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "productName"
                                                    ),
                                                    rules: [
                                                      _vm.fieldIsRequired()
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.commodityInEdit
                                                        .productName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.commodityInEdit,
                                                        "productName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "commodityInEdit.productName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "productCNName"
                                                    ),
                                                    rules: [
                                                      _vm.fieldIsRequired()
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.commodityInEdit
                                                        .productCNName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.commodityInEdit,
                                                        "productCNName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "commodityInEdit.productCNName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c("v-autocomplete", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    items: _vm.countryCodeArray,
                                                    "item-text": "name",
                                                    "item-value": "value",
                                                    rules: [
                                                      _vm.fieldIsRequired()
                                                    ],
                                                    label: _vm.$t(
                                                      "countryOfOrigin"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.commodityInEdit
                                                        .countryOfOrigin,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.commodityInEdit,
                                                        "countryOfOrigin",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "commodityInEdit.countryOfOrigin"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "harmonizedCode"
                                                    ),
                                                    rules: [
                                                      _vm.fieldIsRequired()
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.commodityInEdit
                                                        .harmonizedCode,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.commodityInEdit,
                                                        "harmonizedCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "commodityInEdit.harmonizedCode"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "align-baseline": "",
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c("v-text-field", {
                                                  class: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("quantity"),
                                                    rules: [
                                                      _vm.fieldIsNumber(),
                                                      _vm.fieldIsRequired()
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.commodityInEdit
                                                        .quantity,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.commodityInEdit,
                                                        "quantity",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "commodityInEdit.quantity"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c("v-text-field", {
                                                  class: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("unitPrice"),
                                                    rules: [
                                                      _vm.fieldIsNumber(),
                                                      _vm.fieldIsRequired()
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.commodityInEdit
                                                        .unitPrice,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.commodityInEdit,
                                                        "unitPrice",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "commodityInEdit.unitPrice"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c("v-text-field", {
                                                  class: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("material"),
                                                    rules: [
                                                      _vm.fieldIsRequired()
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.commodityInEdit
                                                        .material,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.commodityInEdit,
                                                        "material",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "commodityInEdit.material"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-flex", { attrs: { xs2: "" } })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "align-baseline": "",
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("description")
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.commodityInEdit
                                                        .commodityDescription,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.commodityInEdit,
                                                        "commodityDescription",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "commodityInEdit.commodityDescription"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.isShowEditCommodityPopup,
                          callback: function($$v) {
                            _vm.isShowEditCommodityPopup = $$v
                          },
                          expression: "isShowEditCommodityPopup"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-686e1b4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-686e1b4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImportUSCommodityWidget.vue
// module id = null
// module chunks = 